var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 2v2h4V2h2v2h4V2h.993c.517 0 .942.386 1 .882L14 3v10.005a1 1 0 0 1-1.007.996H1.007A1 1 0 0 1 0 13.004V3A1 1 0 0 1 1.007 2zm2-2c.556 0 1 .447 1 .999V3H3V.999A.997.997 0 0 1 4 0m6 0c.556 0 1 .447 1 .999V3H9V.999A.997.997 0 0 1 10 0"
})));
export default SvgCalendar;